import React from 'react'
import Card from '../../../CustomComponents/Card'
import { useTranslation } from 'react-i18next';
import { addLineBreaks } from '../../../../utils';
import Arrow from '../../../../assets/images/arrow.png';
import leftArrow from '../../../../assets/images/leftarrow.svg';
import Loader from '../../../CustomComponents/Loader';
import { appTheme } from '../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';


const PatriotAct = ({handleClick}) => {
  const { t } = useTranslation();
  const SubTittleStylesModal = "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px] font-normal sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)]";
  const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);  
  const appThemeData = appTheme(signUpkudzuPlusTrue)

    return (
        <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
          <Card
            cardHeight={'auto'}
            isWhiteForSignup={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            backgroundColor={'--modalcard-bg'} 
            heading={
              <>
            <button type="button" className="flex items-center gap-2 cursor-pointer mb-4 bg-transparent border-none p-0" onClick={() => handleClick('terms')}>
              <img
                src={leftArrow}
                className="md:w-[17px] sm:w-[11px] w-[12px] md:h-[17px] sm:h-[11px] h-[12px] ml-2"
                alt=""
              />

              <span className="text-[#94C3E8] font-[Hanken_Grotesk] font-medium text-[20px] leading-[30px]">
                {t('back')}
              </span>
            </button>
                <span className='font-serif-pro  text-[#2965FB] sm:text-[var(--signup-flow-heading-text)] lg:text-[31px]
                 md:text-[26px] sm:text-[22px] text-[35px] lg:leading-[38px]
                  md:leading-[33px] sm:leading-[29px] leading-[31px]'>{t('take_a_moment')}</span>
                <span className='font-serif-pro sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)] lg:text-[31px]
                 md:text-[26px] sm:text-[22px] text-[35px] lg:leading-[38px]
                  md:leading-[33px] sm:leading-[29px] leading-[31px]'>{t('read_notice')}</span>
              </>
            }
            // subheading={addLineBreaks(t('create_password__subheading3'), SubTittleStylesModal)}
            Cardcaption={t('patriot_act_cardheading')} header={true} footer={true} CardRadius={true}>
           <div className='flex flex-col mt-5 gap-5'>
            <p className="font-hanken-grotesk font-medium text-[var(--modal-text-heading-clr)] text-[16px] leading-[18px] sm:text-[12px] sm:leading-[20px] md:text-[20px] md:leading-[30px]">
              {t("patriot_act_imp_information")}
            </p>            
            <p className="font-normal text-[16px] leading-[24px] text-[var(--modal-text-heading-clr)] font-[Hanken_Grotesk]">
              {t("patriot_act_to_help_the_govrn")}
            </p>           
            </div>
    
            <div className="flex justify-end items-center mt-10 mb-24">
              <button
                type="button"
                className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                   text-[var(--transactions-filter-blue-text)] cursor-pointer flex items-center"
                onClick={()=>handleClick("terms")} // Call handleContinue instead of openPhoneOTPModal directly
              >
                {t('GotIt')}
                
              </button>
            </div>
          </Card>
          {/* {isLoading && <Loader />} */}
        </div>
      )
}

export default PatriotAct